import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

function OAuthCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    const run = async () => {
      const token = searchParams.get('token');
      const errorParam = searchParams.get('error');

      if (errorParam) {
        setError(errorParam);
        setTimeout(() => navigate('/login', { replace: true }), 2500);
        return;
      }

      if (!token) {
        setError('No authentication token received');
        setTimeout(() => navigate('/login', { replace: true }), 2500);
        return;
      }

      const result = await loginWithToken(token);

      if (result.success) {
        navigate('/dashboard', { replace: true });
      } else {
        setError(result.error || 'Authentication failed');
        setTimeout(() => navigate('/login', { replace: true }), 2500);
      }
    };

    run();
  }, [searchParams, navigate, loginWithToken]);

  if (error) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#1a1a1a',
        color: '#c9a962',
        padding: 24,
        textAlign: 'center'
      }}>
        <div>
          <h2>Authentication failed</h2>
          <p>{error}</p>
          <p style={{ opacity: 0.8 }}>Redirecting to login…</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: '#1a1a1a',
      color: '#c9a962'
    }}>
      <div style={{ textAlign: 'center' }}>
        <h2>Logging you in...</h2>
        <p>Please wait while we complete your authentication.</p>
      </div>
    </div>
  );
}

export default OAuthCallback;
